import { sortVisitDetails } from "../../../../utils";
import type { VisitDisplay } from "../types";

export const getVisitDetails = (
  visit: VisitDisplay,
  editMode: boolean
): typeof visit.med_visit_details => {
  let details = visit.med_visit_details ?? [];
  if (!editMode) details = details.filter((d) => d.visit_details?.trim());
  return sortVisitDetails(details);
};
